(function () {
  function split(el) {
    if (!el) return null;
    var text = (el.textContent || "").trim();
    if (!text) return null;

    if (el.dataset.beezySplit === "1") {
      return el.querySelectorAll(".beezy-char");
    }

    el.dataset.beezySplit = "1";
    var wrap = document.createElement("span");
    wrap.className = "beezy-word";

    for (var i = 0; i < text.length; i++) {
      var s = document.createElement("span");
      s.className = "beezy-char";
      s.textContent = text[i];
      wrap.appendChild(s);
    }

    el.textContent = "";
    el.appendChild(wrap);

    return el.querySelectorAll(".beezy-char");
  }

  function cancelAll(chars) {
    if (!chars) return;
    chars.forEach(function (c) {
      c.getAnimations().forEach(function (a) { a.cancel(); });
    });
  }

  function animateNewton(chars) {
    if (!chars || chars.length < 2) return;

    cancelAll(chars);

    var left = chars[0];
    var right = chars[chars.length - 1];

    var A = 14;
    var R = 4;
    var total = 2000;

    var hold = 0.08;
    var hit1 = 0.25;
    var outR = 0.50;
    var hit2 = 0.75;

    left.animate([
      { offset: 0.00, transform: "translateX(" + (-A) + "px) rotate(" + (-R) + "deg)" },
      { offset: hold, transform: "translateX(" + (-A) + "px) rotate(" + (-R) + "deg)" },
      { offset: hit1, transform: "translateX(0px) rotate(0deg)" },
      { offset: hit2, transform: "translateX(0px) rotate(0deg)" },
      { offset: 1.00, transform: "translateX(" + (-A) + "px) rotate(" + (-R) + "deg)" }
    ], { duration: total, iterations: Infinity, easing: "cubic-bezier(.2,.8,.2,1)" });

    right.animate([
      { offset: 0.00, transform: "translateX(0px) rotate(0deg)" },
      { offset: hit1, transform: "translateX(0px) rotate(0deg)" },
      { offset: outR, transform: "translateX(" + (A) + "px) rotate(" + (R) + "deg)" },
      { offset: hit2, transform: "translateX(0px) rotate(0deg)" },
      { offset: 1.00, transform: "translateX(0px) rotate(0deg)" }
    ], { duration: total, iterations: Infinity, easing: "cubic-bezier(.2,.8,.2,1)" });

    var mids = Array.prototype.slice.call(chars, 1, chars.length - 1);
    mids.forEach(function (m, idx) {
      var tiny = Math.max(0.6, 1.6 - idx * 0.2);
      m.animate([
        { offset: 0.00, transform: "translateX(0px) rotate(0deg)" },
        { offset: hit1, transform: "translateX(" + (tiny) + "px) rotate(0deg)" },
        { offset: hit1 + 0.06, transform: "translateX(0px) rotate(0deg)" },
        { offset: hit2, transform: "translateX(" + (-tiny) + "px) rotate(0deg)" },
        { offset: hit2 + 0.06, transform: "translateX(0px) rotate(0deg)" },
        { offset: 1.00, transform: "translateX(0px) rotate(0deg)" }
      ], { duration: total, iterations: Infinity, easing: "linear" });
    });
  }

  function init() {
    var reduce = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (reduce) return;

    var el = document.querySelector(".header__heading-link .h2");
    var chars = split(el);
    if (!chars) return;

    animateNewton(chars);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

  document.addEventListener("shopify:section:load", init);
})();